module.exports = __webpack_public_path__ + "static/media/D18_page_05.a3615fc.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/D18_page_05.mp4
// module id = hliD
// module chunks = 0